export default __webpack_public_path__ + "static/media/Get started-light-1.8680fb16.svg";